export default __webpack_public_path__ + "static/media/Jera_Open_fermentation.850e70b4.jpg";